import { useCallback, useMemo } from "react";
import { useLocalStorage } from "@/lib/Hooks/useLocalStorage";
import { localStorageKeys } from "@/lib/utils";

export function usePinnedSuppliers() {
  const [stored, setStored] = useLocalStorage<string[]>(
    localStorageKeys.PINNED_SUPPLIERS,
    [],
  );

  const pinnedIds = useMemo(() => stored ?? [], [stored]);

  const togglePin = useCallback(
    (id: string) => {
      setStored((prev) => {
        const current = prev ?? [];
        return current.includes(id)
          ? current.filter((pinnedId) => pinnedId !== id)
          : [...current, id];
      });
    },
    [setStored],
  );

  const isPinned = useCallback(
    (id: string) => pinnedIds.includes(id),
    [pinnedIds],
  );

  const partitionByPinned = useCallback(
    <T extends { id: string }>(items: T[]) => ({
      pinned: items.filter((item) => pinnedIds.includes(item.id)),
      unpinned: items.filter((item) => !pinnedIds.includes(item.id)),
    }),
    [pinnedIds],
  );

  return { pinnedIds, isPinned, togglePin, partitionByPinned };
}
